<video *ngIf="internalVideo && supportedVideo && contentAlign === 'CENTER'" width="100%" height="100%"
       [ngStyle]="fit === 'fill-screen' ? { 'object-fit': 'cover' } : {}"
    style="width:100%; pointer-events: none;" autoplay [muted]="true" loop>
    <source [src]="videoUrl" [type]="extension">
    Your browser does not support HTML5 video.
</video>

<video controls *ngIf="internalVideo && supportedVideo && contentAlign !== 'CENTER'" width="100%" height="100%"
    style="width:100%; height: 100%; object-fit: cover;"
       [ngStyle]="fit === 'fill-screen' ? { 'object-fit': 'cover' } : {}">
    <source [src]="videoUrl" [type]="extension">
    Your browser does not support HTML5 video.
</video>
<iframe *ngIf="safeUrl && (!internalVideo || !supportedVideo)" width="100%" height="100%" [src]=safeUrl
    title="YouTube video player" frameborder="0"
    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
    allowfullscreen></iframe>
